'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _dec3, _class, _class2, _temp2;
// import { Link } from 'react-router';
// import config from '../../config';
// remove this one
// import {isLoaded, load as loadWidgets} from 'redux/modules/widgets';

// import 'katex/dist/katex.min.css';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactI18next = require('react-i18next');

var _home = require('redux/modules/home');

var homeActions = _interopRequireWildcard(_home);

var _reactBootstrap = require('react-bootstrap');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _reactKatex = require('react-katex');

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoaded = homeActions.isLoaded,
    loadContents = homeActions.loadContents;
var HomeDev = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    // console.log("asyncConnect");
    if (!isLoaded(getState())) {
      // console.log("not in here?");
      return dispatch(loadContents());
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    directions: state.home.data
  };
}, (0, _extends3.default)({}, homeActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(HomeDev, _Component);

  function HomeDev() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, HomeDev);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = HomeDev.__proto__ || (0, _getPrototypeOf2.default)(HomeDev)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      selectedOption: ''
      // componentDidMount() {
      //   // require('katex/dist/katex.min.css');
      //   // this.forceUpdate();
      //   const _SortableTree = require('react-sortable-tree').default;
      //
      // }

    }, _this.handleChange = function (selectedOption) {
      _this.setState({ selectedOption: selectedOption });
      // selectedOption can be null when the `x` (close) button is clicked
      if (selectedOption) {
        console.log('Selected: ' + selectedOption.label);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(HomeDev, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._ismounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._ismounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Home.scss');
      var selectedOption = this.state.selectedOption;
      // console.log("stylessss....");
      // console.log(styles);
      // require('katex/dist/katex.min.css');
      // require('../../theme/katex.scss');
      // require('./katex.scss');
      // require the logo image both from client and server
      // const logoImage = require('./logo.png');

      var _props = this.props,
          t = _props.t,
          directions = _props.directions;


      var initialData = [{ id: '1', name: 'N1', parent: null }, { id: '2', name: 'N2', parent: null }, { id: '3', name: 'N3', parent: 2 }, { id: '4', name: 'N4', parent: 3 }];
      // let _SortableTree;

      // Update to React > 15.3 to use
      // if (this._ismounted) {
      //   // const _SortableTree = require('react-sortable-tree').default;
      //   const SortableTree = require('react-sortable-tree').default;
      //   return (<SortableTree
      //     treeData={initialData} />);
      // }
      // else {
      //   return (<div></div>)
      // }


      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            _reactBootstrap.Button,
            { bsStyle: 'link', onClick: function onClick() {
                return _this2.props.history.push('/lessons');
              } },
            t('content.all_lessons')
          ),
          _react2.default.createElement(_reactSelect2.default, {
            name: 'form-field-name',
            value: selectedOption,
            onChange: this.handleChange,
            options: [{ value: 'one', label: 'One' }, { value: 'two', label: 'Two' }]
          }),
          _react2.default.createElement(
            _reactBootstrap.Pager,
            null,
            _react2.default.createElement(
              _reactBootstrap.PageItem,
              { next: true, onSelect: function onSelect() {
                  return _this2.props.history.push('/page/2');
                }, href: '/page/2' },
              t('content.next_page'),
              ' \u2192'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            directions !== undefined && directions.map(function (item, i) {
              // console.log(item);
              if (item.active === 1) {
                return _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('b', { dangerouslySetInnerHTML: { __html: item.name } }),
                  _react2.default.createElement(
                    'span',
                    null,
                    ' from '
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { bsStyle: 'link', onClick: function onClick() {
                        return _this2.props.history.push('/lesson/' + item.lessonsId);
                      } },
                    t('content.lesson')
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    item && (0, _reactHtmlParser2.default)(item.data, { decodeEntities: true, transform: function transform(node, index) {
                        if (node.type === 'tag' && node.name === 'span' && node.attribs.class === "math-q") {
                          // node.name = 'InlineMath';
                          // console.log("what");
                          // console.log(node);
                          // console.log(index);
                          return _react2.default.createElement(_reactKatex.InlineMath, { math: node.children[0].data.slice(2, -2) });
                        }

                        //Find image tag: <span><img src=\"content/lessons/28/obitan_1.PNG\" /></span>
                        if (node.type === 'tag' && node.name === 'img') {
                          // console.log(node);
                          if (node.attribs.src.startsWith('content/lessons/')) {
                            // console.log("matchedddd.....");
                            var newSrc = 'http://hochochoc.com/www/' + node.attribs.src; //should be dynamic.... by using env...

                            return _react2.default.createElement('img', { src: newSrc });
                          }
                        }
                      } })
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { bsStyle: 'link', onClick: function onClick() {
                        return _this2.props.history.push('/content/' + item.id);
                      } },
                    t('content.see_more')
                  )
                );
              }
            })
          ),
          _react2.default.createElement(
            _reactBootstrap.Pager,
            null,
            _react2.default.createElement(
              _reactBootstrap.PageItem,
              { next: true, onSelect: function onSelect() {
                  return _this2.props.history.push('/page/2');
                }, href: '/page/2' },
              t('content.next_page'),
              ' \u2192'
            )
          )
        )
      );
    }
  }]);
  return HomeDev;
}(_react.Component), _class2.propTypes = {
  t: _react.PropTypes.func,
  directions: _react.PropTypes.array
}, _temp2)) || _class) || _class) || _class);
exports.default = HomeDev;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/HomeDev.js
// module id = 1528
// module chunks = 0